import pathOr from 'ramda/src/pathOr';
import { createSelector } from 'reselect';
import { reducer, getSearchSelectors } from 'redux-search';
import { GAMES_RESOURCE_NAME } from '../../../constants/search';

export const initialState = {
  [GAMES_RESOURCE_NAME]: {
    text: '',
    result: [],
    unfilteredResult: [],
  },
};

export const searchStateSelector = (state) =>
  pathOr(initialState, ['app', 'search'], state);
export const resourceStateSelector = (name, state) =>
  pathOr({}, ['domain', name, 'byId'], state);

/**
 * getSearchSelectors returns named selectors:
 * text - search text selector
 * result - search result selector. Returns array of IDs
 * unfilteredResult - unfiltered search result selector
 */
export const { text, result } = getSearchSelectors({
  resourceName: GAMES_RESOURCE_NAME,
  resourceSelector: resourceStateSelector,
  searchStateSelector,
});

export const searchTextSelector = createSelector(
  text,
  (searchText) => searchText
);

export const searchResultSelector = createSelector(
  result,
  (searchResult) => searchResult
);

export default reducer;
